import axios from "axios"
import { apiUrl } from "../enumerations/constants"

export const createCategory = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/category`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const updateCategory = async (token, payload) => {
  const { data: response } = await axios.put(`${apiUrl}/category`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const deleteCategory = async (token, id) => {
  const { data: response } = await axios.delete(`${apiUrl}/category/${id}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getCategories = async (token, query) => {
  const { data: response } = await axios.get(`${apiUrl}/categories?${query}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getCategory = async (token, id) => {
  const { data: response } = await axios.get(`${apiUrl}/category?id=${id}`, {
    headers: {
      "Token": token
    }
  })
  return response
}